import React, { Component } from 'react'
import { DonationCard } from '../../component/donationcard'
import Intro from '../../eventimages/intro.png'
import GohsEvent from '../../eventimages/gohsevent.png'
import NSA from '../../eventimages/nsa.png'
import PSHS from '../../eventimages/pshs.png'
import Hockaday from '../../eventimages/hockaday.png'
import MSA from '../../eventimages/msa.png'
import Semester from '../../eventimages/semmeeting.png'
export const Events = () => {
  return (
   <div>
        <h1>Events</h1>
        <p>Here are just some of the many previous events various of our ACE Chapters have held!</p>
        <div className="space-y-12">

            <DonationCard
                image={GohsEvent}
                imageAlt="GOHS Chapter tutoring students"
                title="GOHS Chapter Tutoring"
                description="GOHS ACE tutored students in multiple different subjects at their tutoring session!"
                callout=""
            />

            <DonationCard
                image={NSA}
                imageAlt="ACE x NSA Collaboration"
                title="NSA Event"
                description="ACE collaborated with PESH NSA to host a session for students to create study material!"
                callout=""
            />
            <DonationCard
                image={PSHS}
                imageAlt="PSHS Chapter Meet"
                title="PSHS Chapter Meet"
                description="Plano Senior held their introductory meeting for students, officers, and representatives!"
                callout=""
            />
            <DonationCard
                image={Intro}
                imageAlt="PESH Chapter Meet"
                title="PESH Chapter Meet"
                description="Our PESH Chapter had an introductory meeting for students, officers, and representatives!"
                callout=""
            />
            <DonationCard
                image={Hockaday}
                imageAlt="Hockaday Back to School Booth"
                title="Hockaday Chapter Meet"
                description="Hockaday held a booth at their back to school event to introduce students to ACE!"
                callout=""
            />
            <DonationCard
                image={MSA}
                imageAlt="ACE x MSA Event"
                title="MSA Event"
                description="ACE collaborated with MSA to hold a session to create review material for service hours!"
                callout=""
            />
            <DonationCard
                image={Semester}
                imageAlt="PESH Interest Meeting"
                title="PESH Interest Meeting"
                description="The PESH Chapter held a meeting to introduce important information to students about our mission and the work being done throughout the school year!"
                callout=""
            />
            </div>
    </div>
  )
}